<template>
  <aside :class="[
    'fixed lg:relative transition-all duration-300 ease-in-out',
    'bg-[#11111b] text-white shadow-lg z-20 flex flex-col h-screen',
    isOpen ? 'w-[200px]' : 'w-20',
  ]">
    <div class="flex items-center justify-between p-4">
      <div class="flex-shrink-0">
        <!-- <a href="/">
          <img src="@/assets/logo.png" alt="Logo" :class="[
            'transition-all duration-300',
            isOpen ? 'h-[80px] w-[80px]' : 'h-10 w-10',
          ]" />
        </a> -->
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto">
      <div class="p-4 space-y-6">
        <!-- <div>
          <h2 v-show="isOpen" class="px-2 text-xs font-semibold text-gray-500 uppercase mb-3">
            General
          </h2>
          <div class="space-y-1">
            <router-link to="/admin/dashboard"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/dashboard'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <LayoutDashboardIcon class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Dashboard</span>
            </router-link>

          </div>
        </div> -->
        <div>
          <h2 v-show="isOpen" class="px-2 text-xs font-semibold text-gray-500 uppercase mb-3">
            Management
          </h2>
          <div class="space-y-1">

            <router-link to="/admin/hero"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/hero'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <House class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Hero</span>
            </router-link>
            <router-link to="/admin/services"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/services'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <CookingPot class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Service</span>
            </router-link>

            <router-link to="/admin/projects"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/projects'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <StickyNote class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Projects</span>
            </router-link>
            <router-link to="/admin/blogs"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/blogs'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <Rss class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Blogs</span>
            </router-link>
            <router-link to="/admin/categories"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/categories'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <Folder class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Categories</span>
            </router-link>
            <router-link to="/admin/messages"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/messages'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <Mail class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Messages</span>
            </router-link>
            <h2 v-show="isOpen" class="px-2 text-xs font-semibold text-gray-500 uppercase mb-3">
              Settings
            </h2>

            <router-link to="/admin/settings"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/settings'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <Settings class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Settings</span>
            </router-link>
            <!-- <router-link to="/admin/login-logs"
              class="flex items-center px-3 py-2 rounded-[10px] transition-colors duration-200" :class="[
                $route.path === '/admin/login-logs'
                  ? 'bg-white text-black'
                  : 'text-white hover:bg-black/10',
              ]">
              <Shield class="h-5 w-5" :class="isOpen ? 'mr-3' : 'mx-auto'" />
              <span v-show="isOpen">Login Logs</span>
            </router-link> -->
          </div>
        </div>
      </div>
    </nav>
  </aside>
</template>

<script setup>
import { Settings, StickyNote, House, CookingPot, Mail, Folder, Rss, Shield } from 'lucide-vue-next';
import { useRouter, useRoute } from 'vue-router';

// Define props
defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});
</script>